<template>
  <!-- 对话框 -->
  <el-dialog title="添加集团" :visible.sync="show" :before-close="closeDialog" style="width:1000px; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">

        <el-form-item label="集团名称 :" label-width='130px'>
          <el-input v-model="submit_data.group_name" :placeholder="submit_rules.group_name.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>


        <el-form-item label="老板电话 :" label-width='130px'>
          <el-input v-model="submit_data.consumer_phone" placeholder="请输入老板电话" maxlength="11" style="width: 160px;">
          </el-input>
        </el-form-item>


        <el-form-item label="账户金额:" label-width='130px'>
          <el-input v-model="submit_data.balance" :placeholder="submit_rules.balance.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>


      </el-form>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button type="primary" @click="addGroup">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

      },

    },
    data() {
      return {

        show: false,




        cityList: [],
        value_city_code: '',

        // 表单提交数据
        submit_data: {
          group_name: '',
          balance: '',
          consumer_phone:''
        },

        submit_rules: {

          group_name: {
            placeholder: '请输入集团名称',
            rules: {
              required: true,
              message: '集团名称不能超过50字',
              regulation: 'lt_str',
              rulesData: 50
            }
          },
          balance: {
            placeholder: '请输入金额',
            rules: {
              required: true,
              message: '金额错误',
              regulation: 'egt_str',
              rulesData: 0
            }
          }

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {



      // 关闭方法
      closeDialog() {

        _this.show = false;

        _this.submit_data = {
          group_name: '',
          balance: '',
          consumer_phone:''
        }
      },

      // 提交按钮
      addGroup() {

        _this.$post(
            '/group/addGroupWalletSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {


            _this.$message.success(res.msg);

            _this.closeDialog();

            _this.$emit('onSubmit');


          }).catch((err) => {

          })

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>